"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.web3Factory = void 0;
const web3_1 = __importDefault(require("web3"));
const networkInfos_helper_1 = require("../../helpers/networkInfos/networkInfos.helper");
const config = {
    77: 'https://sokol.arianee.net',
    137: 'https://polygon.arianee.net',
    80001: 'https://matic-mumbai.chainstacklabs.com',
    99: 'https://poa.arianee.net',
    1: 'https://mainnet.infura.io/v3/2a9cbd5377b6406f8780c2958dc7bad6',
    3: 'https://ropsten.infura.io/v3/2a9cbd5377b6406f8780c2958dc7bad6',
    42: 'https://kovan.infura.io/v3/2a9cbd5377b6406f8780c2958dc7bad6'
};
exports.web3Factory = (chainIdOrUrl) => __awaiter(void 0, void 0, void 0, function* () {
    if (chainIdOrUrl.startsWith('http://') || chainIdOrUrl.startsWith('https://') || chainIdOrUrl.startsWith('ws://')) {
        return new web3_1.default(chainIdOrUrl);
    }
    else if (config[chainIdOrUrl]) {
        return new web3_1.default(config[chainIdOrUrl]);
    }
    else {
        const networkInfo = yield networkInfos_helper_1.getNetworkInfo(chainIdOrUrl);
        const goodrpcUrls = getGoodRpcUrl(networkInfo.rpc);
        return new web3_1.default(goodrpcUrls[0]);
    }
});
const getGoodRpcUrl = (rpcUrls) => {
    return rpcUrls.filter(rpcUrl => !rpcUrl.includes('$'));
};
//# sourceMappingURL=web3Factory.js.map